import { post, get } from "../xhr"

export function getChatRooms () {
    return get('users/conversations', 'application/json')
}

export function getChatRoom(id) {
    return get(`users/conversation/${id}`, 'application/json')
}

export async function updateRoom (data, id) {
    const formData = new FormData();
    for await (let [key, member] of data.members) {
        formData.append(`members[${key}]`, member);
    }

    formData.append('title', data.title);
    formData.append('icon', data.icon);
    return post(`chat/update-room/${id}`, 'multipart/form-data', formData)
}